<template>
  <div class="user-profile">
    <h1 aria-live="assertive">This is user profile</h1>
  </div>
</template>
